import RoutesMap from "../../route_control/RouteControl"
import { lazy } from "react"

const Dashboard = lazy(() => import("../../pages/dashboard/Dashboard"))
const ModuleDashboard = lazy(() => import("../../pages/dashboard/ModuleDashboard"))

export const DashboardRouteImport = {
    RoutesMap,
    Dashboard,
    ModuleDashboard,
}